import "./Blog.css";
import BlogPost from "./BlogPost";
import * as bt from "../posts/BlogTexts";

const Blog = () => {
  return (
    <div className="blog-site-container">
      <h1>Blog</h1>
      <div className="blog-items-container">
        <BlogPost
          title={bt.secTitle}
          subText={bt.secSubText}
          date={bt.secDate}
          link={bt.secLink}
        />
        <BlogPost
          title={bt.firstTitle}
          subText={bt.firstSubText}
          date={bt.firstDate}
          link={bt.firstLink}
        />
      </div>
    </div>
  );
};

export default Blog;
